import { useState, useEffect, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';

import { Box, Grid, Paper, Typography, MenuItem } from '@mui/material';
import { Add, Mode } from '@mui/icons-material';

import { Button, DataLoading, TextField } from '../../components/common';
import colors from '../../assets/colors';
import { EditFarmModal, AddFarmModal } from '../../components/Modals';
import { farm } from '../../utils/api';
import FarmContext from '../../store/farm-context';

export default function FarmSelect(props) {
  const [farms, setFarms] = useState(null);
  const farmCTX = useContext(FarmContext);
  const [selectedFarm, setSelectedFarm] = useState();
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openAddModal, setOpenAddModal] = useState(false);

  const handleOpenAddModal = () => setOpenAddModal(true);
  const handleOpenEditModal = () => setOpenEditModal(true);

  const history = useHistory();
  const theme = useTheme();

  const updateFarms = () => {
    farm
      .all()
      .then((result) => {
        if (result.status === 200) {
          if (farmCTX.farmID === null && result.data[0]) {
            farmCTX.setFarmID(result.data[0].id);
          } else if (!result.data[0]) {
            farmCTX.clearFarmID();
          } else if (farmCTX.farmID !== null) {
            if (!checkIfFarmIDValid(result.data)) farmCTX.clearFarmID();
          }
          setFarms(result.data);
        } else {
          history.push('/login');
        }
      })
      .catch((err) => {
        try {
          if (err.response.status === 403) {
            history.push('/login');
          }
        } catch (e) {}
      });
  };

  const checkIfFarmIDValid = (data) => {
    const idArray = data.map((data) => data.id);
    return idArray.includes(farmCTX.farmID);
  };

  useEffect(() => {
    updateFarms();
    // eslint-disable-next-line
  }, [openAddModal, openEditModal, farmCTX.farmID]);

  useEffect(() => {
    if (farmCTX.farmID !== null && farms) {
      let farm = farms.find((element) => element.id === farmCTX.farmID);
      setSelectedFarm(farm);
    }
    //eslint-disable-next-line
  }, [farms]);

  const changeFarm = (event) => {
    farmCTX.setFarmID(event.target.value);
    if (props.onChange) props.onChange();
  };

  return (
    <>
      {farms == null ? (
        <Grid
          container
          justifyContent="center"
          alignItems="center"
          alignContent="center"
          sx={{ mt: 10 }}
        >
          <DataLoading />
        </Grid>
      ) : farms?.length > 0 ? (
        <>
          <Grid
            container
            justifyContent="center"
            alignItems="center"
            alignContent="center"
          >
            <Grid
              item
              xs={11}
              sm={8}
              md={7}
              lg={6}
              xl={6}
              component={Paper}
              sx={{
                backgroundColor: colors.oldAgroweGreen,
                color: colors.white,
                mt: 10,
                [theme.breakpoints.up('lg')]: {
                  mr: 10,
                },

                textAlign: 'center',
              }}
            >
              <Box
                textAlign="left"
                sx={{
                  p: 2,
                }}
              >
                <Grid container justifyContent="space-between">
                  <Typography variant="h6"> NAZWA GOSPODARSTWA: </Typography>
                  <Typography variant="h6" align="right">
                    {selectedFarm?.farmName}
                  </Typography>
                </Grid>
                <Grid container justifyContent="space-between">
                  <Typography variant="h6"> IMIĘ: </Typography>
                  <Typography variant="h6" align="right">
                    {selectedFarm?.name}
                  </Typography>
                </Grid>
                <Grid container justifyContent="space-between">
                  <Typography variant="h6">NAZWISKO: </Typography>
                  <Typography variant="h6" align="right">
                    {selectedFarm?.surname}
                  </Typography>
                </Grid>
                <Grid container justifyContent="space-between">
                  <Typography variant="h6">PESEL: </Typography>
                  <Typography variant="h6" align="right">
                    {selectedFarm?.pesel}
                  </Typography>
                </Grid>
                <Grid container justifyContent="space-between">
                  <Typography variant="h6">NUMER ARIMR: </Typography>
                  <Typography variant="h6" align="right">
                    {selectedFarm?.arimr}
                  </Typography>
                </Grid>
                <Grid container justifyContent="space-between">
                  <Typography variant="h6">NIP: </Typography>
                  <Typography variant="h6" align="right">
                    {selectedFarm?.nip}
                  </Typography>
                </Grid>
                <Grid container justifyContent="space-between">
                  <Typography variant="h6">ADRES: </Typography>
                  <Typography
                    variant="h6"
                    align="right"
                    sx={{ wordBreak: 'break-word' }}
                  >
                    {selectedFarm?.address}
                  </Typography>
                </Grid>
              </Box>
            </Grid>
            <Grid
              item
              xs={11}
              sm={7}
              md={6}
              lg={4}
              xl={4}
              alignContent="center"
              justifyContent="center"
              sx={{
                mt: 4,
                [theme.breakpoints.up('lg')]: {
                  mt: 12,
                },
              }}
            >
              <Grid item>
                <TextField
                  bordered
                  select
                  fullWidth
                  label="Lista gospodarstw"
                  value={farms?.length > 0 ? farmCTX.farmID ?? '' : ''}
                  sx={{
                    textAlign: 'center',
                    mb: 2,
                    '& 	.MuiInputBase-input': {
                      backgroundColor: colors.rowLight,
                    },
                    maxWidth: props.maxSelectWidth,
                  }}
                  onChange={changeFarm}
                >
                  {farms.map((farm) => (
                    <MenuItem value={farm.id} key={farm.id}>
                      {farm.farmName + ' ' + farm.name + ' ' + farm.surname}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>
              <Grid item sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                <Button
                  fullWidth
                  variant="contained"
                  onClick={handleOpenEditModal}
                  sx={{
                    mb: 2,
                    background: colors.oldAgroweGreen,
                    py: 1,
                    px: 3,
                    minWidth: 210,
                  }}
                >
                  <Mode sx={{ mr: 2 }} />
                  EDYTUJ GOSPODARSTWO
                </Button>
              </Grid>
              <Grid item sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                <Button
                  variant="contained"
                  fullWidth
                  onClick={handleOpenAddModal}
                  sx={{
                    background: colors.oldAgroweGreen,
                    borderRadius: 5,
                    py: 1,
                    px: 3,
                    minWidth: 210,
                  }}
                >
                  <Add sx={{ mr: 2 }} />
                  DODAJ GOSPODARSTWO
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </>
      ) : (
        <Grid container justifyContent="center">
          <Button
            variant="contained"
            onClick={handleOpenAddModal}
            sx={{
              background: colors.oldAgroweGreen,
              color: colors.white,
              borderRadius: 5,
              mt: 15,
              '&:hover': {
                background: `${colors.oldAgroweGreen}99`,
              },
              py: 1,
              px: 3,
            }}
          >
            <Add sx={{ mr: 2 }} />
            DODAJ GOSPODARSTWO
          </Button>
        </Grid>
      )}
      {openEditModal && (
        <EditFarmModal
          open={openEditModal}
          setOpen={setOpenEditModal}
          farm={selectedFarm}
          update={updateFarms}
        />
      )}
      {openAddModal && (
        <AddFarmModal
          open={openAddModal}
          setOpen={setOpenAddModal}
          update={updateFarms}
        />
      )}
    </>
  );
}
